import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "bg-gray-950/80 space-y-6 py-5",
  ref: "targetElement"
}
const _hoisted_2 = { class: "w-full px-3 md:px-3" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = { class: "grid grid-cols-12 gap-3 md:gap-0 w-full px-0" }
const _hoisted_5 = { class: "col-span-9 md:col-span-10 xl:col-span-11 px-5" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-3 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-1.5 sm:gap-2 xl:gap-3"
}
const _hoisted_7 = { class: "grid grid-cols-3 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-1.5 sm:gap-2 xl:gap-3" }
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "text-white text-[10px]" }
const _hoisted_11 = {
  key: 0,
  class: "absolute z-10 top-0 right-0 flex justify-center items-center w-max px-0.5"
}
const _hoisted_12 = ["onClick", "title"]
const _hoisted_13 = {
  class: "relative z-0 top-0 left-0 group w-full h-full",
  tabindex: "0"
}
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 0,
  class: "absolute z-10 top-0 left-0 hidden group-hover:flex group-focus:flex group-active:flex justify-center items-center w-full h-full bg-black/50"
}
const _hoisted_16 = ["onClick", "title"]
const _hoisted_17 = {
  key: 1,
  class: "absolute z-10 top-0 left-0 hidden flex justify-center items-center w-full h-full bg-black/50"
}
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "col-span-3 md:col-span-2 xl:col-span-1" }

export function render(_ctx, _cache) {
  const _component_Message = _resolveComponent("Message")
  const _component_GameNavbar = _resolveComponent("GameNavbar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Error "),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "error",
          closable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.error), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" Products "),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("label", {
                for: "default-search",
                class: "mb-2 text-sm font-medium text-gray-900 sr-only"
              }, "ค้นหา", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_3, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none" }, [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-gray-500",
                    "aria-hidden": "true",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 20 20"
                  }, [
                    _createElementVNode("path", {
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                    })
                  ])
                ], -1 /* HOISTED */)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchQuery) = $event)),
                  type: "search",
                  id: "default-search",
                  class: "block w-full p-4 ps-10 text-sm text-white bg-[#000000d4] border border-[#00a782] focus:border-[#00a782] focus:ring-2 focus:ring-green-500 focus:outline-none rounded-lg",
                  placeholder: "ค้นหา..."
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.searchQuery]
                ])
              ])
            ])
          ])
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createCommentVNode(" Product "),
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-lg text-[#10ffa9] font-semibold mb-2" }, "รายการแข่งขัน", -1 /* HOISTED */)),
          _createCommentVNode(" Product Loading "),
          (_ctx.loadingProducts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(30, (n) => {
                  return _createElementVNode("div", {
                    key: 'game-skeleton-' + n,
                    class: "h-32 md:h-32 xl:h-36 2xl:h-40 bg-[#002c18a1] animate-pulse rounded"
                  })
                }), 64 /* STABLE_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" Product List "),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.clickSport && _ctx.clickSport(...args))),
                    class: "col-span-3 md:col-span-6 lg:col-span-4 xl:col-span-5 md:row-span-2 lg:row-span-3 cursor-pointer"
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("img", {
                      src: "https://topgame-storage.sgp1.cdn.digitaloceanspaces.com/theme/Askmebet.gif",
                      alt: "Askmebet",
                      class: "overflow-hidden rounded-lg"
                    }, null, -1 /* HOISTED */)
                  ])),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProducts, (product) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: product.productCode,
                      class: "relative z-0 h-32 md:h-32 xl:h-36 2xl:h-40 w-full border rounded shadow-sm transition hover:bg-primary hover:text-primary overflow-hidden!",
                      title: product.productName?.toLocaleUpperCase()
                    }, [
                      _createElementVNode("div", {
                        class: "absolute z-10 top-0 left-0 flex justify-center items-center w-max gap-1 bg-black/60 rounded-br px-0.5 cursor-default",
                        title: 'กำลังเล่นอยู่: ' + (product?.online || 0)
                      }, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "relative flex size-2" }, [
                          _createElementVNode("span", { class: "absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" }),
                          _createElementVNode("span", { class: "relative inline-flex size-2 rounded-full bg-green-500" })
                        ], -1 /* HOISTED */)),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(product?.online || 0), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_9),
                      (_ctx.auth.isLoggedIn)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("span", {
                              onClick: $event => (_ctx.clickBtnFavorite(product?.loginCode || '', product?.isFavorite || false)),
                              title: !product.isFavorite ? 'เพิ่มลงรายการโปรด': 'ลบออกจากรายการโปรด'
                            }, [
                              (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass(["size-6 drop-shadow cursor-pointer hover:text-pink-600", {'text-white': product.isFavorite === false, 'text-pink-600': product.isFavorite === true}]),
                                "aria-hidden": "true",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                fill: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [...(_cache[6] || (_cache[6] = [
                                _createElementVNode("path", { d: "m12.75 20.66 6.184-7.098c2.677-2.884 2.559-6.506.754-8.705-.898-1.095-2.206-1.816-3.72-1.855-1.293-.034-2.652.43-3.963 1.442-1.315-1.012-2.678-1.476-3.973-1.442-1.515.04-2.825.76-3.724 1.855-1.806 2.201-1.915 5.823.772 8.706l6.183 7.097c.19.216.46.34.743.34a.985.985 0 0 0 .743-.34Z" }, null, -1 /* HOISTED */)
                              ]))], 2 /* CLASS */))
                            ], 8 /* PROPS */, _hoisted_12)
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("img", {
                          class: _normalizeClass(["static z-0 w-full h-full top-0 left-0", {'group-hover:grayscale': product.active, 'grayscale': !product.active }]),
                          src: product.logo?.vertical,
                          alt: product.gameName?.toLocaleUpperCase()
                        }, null, 10 /* CLASS, PROPS */, _hoisted_14),
                        (product.active)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("button", {
                                onClick: $event => (_ctx.clickGame(product?.loginCode || '', product?.gameType)),
                                title: 'เล่น '+product.gameName?.toLocaleUpperCase(),
                                type: "button",
                                class: "w-16 text-white text-xs font-semibold bg-yellow-400 rounded-lg py-1 shadow cursor-pointer"
                              }, "เล่น", 8 /* PROPS */, _hoisted_16)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[7] || (_cache[7] = [
                              _createElementVNode("span", { class: "text-xs font-bold" }, "ปิดปรับปรุง", -1 /* HOISTED */)
                            ]))]))
                      ]),
                      _createElementVNode("h4", {
                        title: product.gameName?.toLocaleUpperCase(),
                        class: "absolute z-10 bottom-0 left-1/2 -translate-x-1/2 w-full text-white text-[11px] font-semibold truncate bg-black/60 px-1 cursor-default"
                      }, _toDisplayString(product.gameName?.toUpperCase()), 9 /* TEXT, PROPS */, _hoisted_18)
                    ], 8 /* PROPS */, _hoisted_8))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_GameNavbar)
      ])
    ])
  ], 512 /* NEED_PATCH */))
}